const localhostHosts = new Set(['localhost', '127.0.0.1', '0.0.0.0'])

function parseUrl(value?: string | null) {
  if (!value) {
    return null
  }

  try {
    return new URL(value)
  } catch {
    return null
  }
}

function shouldUseConfiguredOrigin(currentOrigin?: string | null) {
  const parsedCurrent = parseUrl(currentOrigin)

  if (!parsedCurrent) {
    return true
  }

  return localhostHosts.has(parsedCurrent.hostname)
}

export function getAppOrigin(currentOrigin?: string | null) {
  const configuredOrigin = process.env.NEXT_PUBLIC_APP_URL?.trim()

  if (configuredOrigin && shouldUseConfiguredOrigin(currentOrigin)) {
    const parsedConfigured = parseUrl(configuredOrigin)
    if (parsedConfigured) {
      return parsedConfigured.origin
    }
  }

  const parsedCurrent = parseUrl(currentOrigin)
  if (parsedCurrent) {
    return parsedCurrent.origin
  }

  if (configuredOrigin) {
    const parsedConfigured = parseUrl(configuredOrigin)
    if (parsedConfigured) {
      return parsedConfigured.origin
    }
  }

  return 'http://localhost:3000'
}

export function getOAuthCallbackUrl(currentOrigin?: string | null) {
  return new URL('/auth/callback', getAppOrigin(currentOrigin)).toString()
}